/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityDataleaksAggResult } from './ControlEntityDataleaksAggResult';
import {
    ControlEntityDataleaksAggResultFromJSON,
    ControlEntityDataleaksAggResultFromJSONTyped,
    ControlEntityDataleaksAggResultToJSON,
} from './ControlEntityDataleaksAggResult';
import type { ControlEntityDataleaksInnerData } from './ControlEntityDataleaksInnerData';
import {
    ControlEntityDataleaksInnerDataFromJSON,
    ControlEntityDataleaksInnerDataFromJSONTyped,
    ControlEntityDataleaksInnerDataToJSON,
} from './ControlEntityDataleaksInnerData';

/**
 * 
 * @export
 * @interface EntityDataLeaksAggResponse
 */
export interface EntityDataLeaksAggResponse {
    /**
     * 
     * @type {number}
     * @memberof EntityDataLeaksAggResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityDataLeaksAggResponse
     */
    total_emails?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityDataLeaksAggResponse
     */
    emails?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityDataLeaksAggResponse
     */
    features?: Array<string>;
    /**
     * 
     * @type {Array<ControlEntityDataleaksInnerData>}
     * @memberof EntityDataLeaksAggResponse
     */
    events?: Array<ControlEntityDataleaksInnerData>;
}

/**
 * Check if a given object implements the EntityDataLeaksAggResponse interface.
 */
export function instanceOfEntityDataLeaksAggResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EntityDataLeaksAggResponseFromJSON(json: any): EntityDataLeaksAggResponse {
    return EntityDataLeaksAggResponseFromJSONTyped(json, false);
}

export function EntityDataLeaksAggResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityDataLeaksAggResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'total_emails': !exists(json, 'total_emails') ? undefined : json['total_emails'],
        'emails': !exists(json, 'emails') ? undefined : json['emails'],
        'features': !exists(json, 'features') ? undefined : json['features'],
        'events': !exists(json, 'events') ? undefined : ((json['events'] as Array<any>).map(ControlEntityDataleaksInnerDataFromJSON)),
    };
}

export function EntityDataLeaksAggResponseToJSON(value?: EntityDataLeaksAggResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'total_emails': value.total_emails,
        'emails': value.emails,
        'features': value.features,
        'events': value.events === undefined ? undefined : ((value.events as Array<any>).map(ControlEntityDataleaksInnerDataToJSON)),
    };
}

